const DATE_INPUT_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
const DATE_INPUT_MESSAGE = "Please choose a valid date that is today or later.";
const EMAIL_VALUE_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const EMAIL_INPUT_MESSAGE =
  "Please enter a valid email address (e.g. name@example.com).";

export const EMAIL_INPUT_PATTERN = "[^\\s@]+@[^\\s@]+\\.[^\\s@]+";

export function getLocalDateString(date: Date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function isValidCalendarDate(value: string) {
  if (!DATE_INPUT_PATTERN.test(value)) {
    return false;
  }

  const [year, month, day] = value.split("-").map(Number);
  const parsed = new Date(year, month - 1, day);

  return (
    parsed.getFullYear() === year &&
    parsed.getMonth() === month - 1 &&
    parsed.getDate() === day
  );
}

export function isSelectableFormDate(value: string) {
  return isValidCalendarDate(value) && value >= getLocalDateString();
}

export function applyDateInputValidity(input: HTMLInputElement) {
  input.setCustomValidity(
    input.value && !isSelectableFormDate(input.value) ? DATE_INPUT_MESSAGE : "",
  );
}

export function isValidEmail(value: string) {
  return EMAIL_VALUE_PATTERN.test(value.trim());
}

export function applyEmailInputValidity(input: HTMLInputElement) {
  const value = input.value.trim();
  const missingDomain =
    value.includes("@") && !EMAIL_VALUE_PATTERN.test(value);
  input.setCustomValidity(missingDomain ? EMAIL_INPUT_MESSAGE : "");
}
